import { useState } from 'react';

import type { FormQuestionOption, PublicationFormQuestion } from '~/interfaces/form';

import MultipleChoiceInput from './MultipleChoiceInput';

interface Props {
  question: PublicationFormQuestion;
}

const MultipleChoiceInputs = ({ question }: Props) => {
  const [checkedBoxes, setCheckedBoxes] = useState(0);

  return (
    <fieldset className="mt-2 space-y-2">
      {question.form_question_options.map((questionOption: FormQuestionOption) => {
        return (
          <MultipleChoiceInput
            key={questionOption.id}
            question={question}
            questionOption={questionOption}
            checkedBoxes={checkedBoxes}
            setCheckedBoxes={setCheckedBoxes}
          />
        );
      })}
    </fieldset>
  );
};

export default MultipleChoiceInputs;
